export enum IntegrationType {
  Datadog = 'datadog',
  DatadogUS3 = 'datadog_us3',
  DatadogUS5 = 'datadog_us5',
  DatadogEU = 'datadog_eu',
  DatadogUS1Fed = 'datadog_us1_fed',
  Pagerduty = 'pagerduty',
  Newrelic = 'newrelic',
  Grafana = 'grafana',
  Appdynamics = 'appdynamics',
  Prometheus = 'prometheus',
  Dynatrace = 'dynatrace',
  AWS = 'aws',
  K6 = 'k6',
  Custom = 'custom',
  LoadGeneratorCustom = 'load_generator_custom'
}

export enum ExternalIntegrationType {
  LoadGenerator = 'LOAD_GENERATOR',
  StatusCheck = 'STATUS_CHECK'
}
